import { AuthGuard } from '@/auth/auth-guards';
import { activationTabsMessages } from '@/components/Activations/Layout/ActivationTabsMessages';
import { ActivationViewType, Permission } from '@art-basel/artbasel-lib-platform';
import type { RouteLocation, RouteRecordRaw } from 'vue-router';
import { linkInBioRoutePaths } from './link-in-bio-route-paths';

export const linkInBioRoutes: Array<RouteRecordRaw> = [
  {
    meta: { title: activationTabsMessages.dashboard },
    path: linkInBioRoutePaths.BASE,
    beforeEnter: (to: RouteLocation) => AuthGuard(to, Permission.READ_ACTIVATIONS),
    children: [
      {
        meta: { title: activationTabsMessages.dashboard },
        path: linkInBioRoutePaths.ROOT,
        component: () => import(`@/views/activation/configure-activation/ConfigureActivation.vue`),
        beforeEnter: (to: RouteLocation) => AuthGuard(to, Permission.READ_ACTIVATIONS),
        props: { viewType: ActivationViewType.LINK_IN_BIO },
      },
      {
        meta: { title: activationTabsMessages.dashboard },
        path: linkInBioRoutePaths.CONFIGURE,
        component: () => import(`@/views/activation/configure-activation/ConfigureActivation.vue`),
        beforeEnter: (to: RouteLocation) => AuthGuard(to, Permission.READ_ACTIVATIONS),
        props: { viewType: ActivationViewType.LINK_IN_BIO },
      },
    ],
  },
];
